import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserGuidesService } from 'src/app/core/services/user-guides.service';

declare var html2pdf: any;

@Component({
  selector: 'app-user-guide-view',
  templateUrl: './user-guide-view.component.html',
  styleUrls: ['./user-guide-view.component.scss']
})
export class UserGuideViewComponent {
  guide: any = null;
  loading = true;
  readOnly = false;

  constructor(
    public dialogRef: MatDialogRef<UserGuideViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private guidesService: UserGuidesService,
  ) { }

  ngOnInit() {
    this.readOnly = this.data.readOnly || false;
    this.guidesService.getGuide(this.data.key).subscribe({
      next: (res: any) => {
        this.guide = res;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  onEdit() {
    this.dialogRef.close('edit');
  }

  downloadPdf() {
    const element = document.getElementById('guide-content');
    if (!element) return;

    const opt = {
      margin: [10, 10, 10, 10],
      filename: `${this.guide.key}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };

    html2pdf().set(opt).from(element).save();
  }

  close() {
    this.dialogRef.close();
  }
}
